



























































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { WarehousePackage } from "@/models/warehousePackage";
import AccountCell from "@/components/cells/Account.vue";

import { NSLog } from "@/helpers/log";
import { find as FindAccountDialog } from "@/dialogs/account";
import billing from "@/services/billing";
import { Permission } from '@/models/permission';
import { Account } from '@/models/account'
import { search as SearchPackageDialog } from "@/dialogs/package";
import Loader from '../../components/loader.vue'
import { Package } from "@/models/package";
const log = NSLog("view/ManageUsers");

@Component({
  components: {
    loader,
    SearchPackageDialog,
  },
})
export default class ManageUsers extends Vue {
  loading = true;
  showPackageSearch = false;
  productMails = [];
  
  @Mutation("setLastErr") public setLastErr: any;

  mounted() {
    this.loadDynamicMails();
  }

  async loadDynamicMails() {
    // try {
    //   const perms = await billing.listAllDynamicMails()
    //   this.permissions = perms;
    // } catch (err) {
    //   this.setLastErr(err);
    // }

    // const permTypes = {} as any;
    // const byAccMap = this.permissions.reduce((prev, curr) => {
    //   permTypes[curr.permission] = true;
    //   prev[curr.account_id] = prev[curr.account_id] || {};
    //   prev[curr.account_id][curr.permission] = curr;
    //   curr._loading = false;
    //   return prev;
    // }, ({} as any));

    // this.byAccount = Object.keys(byAccMap).map((account_id) => ({ account_id, ...byAccMap[account_id] }));
    // this.allPermissionTypes = Object.keys(permTypes);

    this.loading = false;
  }

  get headers() {
    const hdrs: any = [
      { text: "Product", value: "title" },
      { text: "Short Code", value: "short_code" },
      // { text: "Condition", value: "condition" },
      { text: "Mail Template", value: "mail_template" },
      { text: "Actions", value: "actions", sortable: false },
    ];
    return hdrs;
  }

  private async setPkg(pkg: Package | false) {
    if (!pkg) {
      this.showPackageSearch = false;
      return;
    }
    this.showPackageSearch = false;
    this.loading = true;
    // await this.togglePermission(account.id, 'orderingadmin', 'can_read', true);
    // await this.loadPermissions();
    this.loading = false;
  }

}
